import { Button } from "@/components/ui/button";

const formattedDate = (value) => new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
}).format(new Date(value));

export const PlanView = ({ result, savedAt, onRetake, onDelete }) => (
  <section className="supplement-plan" role="region" aria-label="Your plan" data-testid="supplement-plan-region">
    {result.basis_label && <p className="supplement-basis" data-testid="supplement-basis-label">{result.basis_label}</p>}
    <div className="supplement-plan__heading">
      <h2 data-testid="supplement-plan-heading">{savedAt ? "Your last plan" : "Your plan"}</h2>
      {savedAt && <time dateTime={savedAt} data-testid="supplement-plan-date">{formattedDate(savedAt)}</time>}
    </div>
    <div className="supplement-core" data-testid="supplement-core-list">
      {result.core.map((item, index) => (
        <article className={`supplement-plan-card supplement-plan-card--${item.tier.toLowerCase()}`} key={`${item.label}-${index}`} data-testid={`supplement-core-card-${index}`}>
          <span className="sr-only">{item.tier}</span>
          <h3 data-testid={`supplement-core-label-${index}`}>{item.label}</h3>
          <strong data-testid={`supplement-core-headline-${index}`}>{item.headline}</strong>
          {item.reason && <p data-testid={`supplement-core-reason-${index}`}>{item.reason}</p>}
          {item.detail.map((line, lineIndex) => <p key={`${line}-${lineIndex}`} data-testid={`supplement-core-detail-${index}-${lineIndex}`}>{line}</p>)}
        </article>
      ))}
      {result.red && (
        <article className="supplement-plan-card supplement-plan-card--red" data-testid="supplement-red-card">
          <span className="sr-only">{result.red.tier}</span>
          <p data-testid="supplement-red-text">{result.red.text}</p>
        </article>
      )}
    </div>
    <div className="supplement-actions">
      <Button variant="outline" onClick={onRetake} data-testid="supplement-retake-button">Retake</Button>
      <Button variant="ghost" onClick={onDelete} data-testid="supplement-delete-button">Delete my answers</Button>
    </div>
  </section>
);